export const addDollarSymbol = amount => {
  if (amount < 0) return amount.toString().replace(/-/, '-$');
  return `$${amount}`;
};
